module.exports = __webpack_public_path__ + "img/about4.75397288.png";